import SearchWidget from '../../../shared/components/SearchWidget';

const Races = ({ value, dictionary, onChoose }) => {
  const items = [
    { id: 0, name: 'Все рейсы (возможны доплаты)' },
    { id: 1, name: 'Только чартер' },
  ];
  const title = value ? 'Только чартер' : 'Все рейсы';
  return (
    <SearchWidget
      cssClass="races"
      type="select"
      label="Авиарейсы"
      title={title}
      items={items}
      value={value}
      buttonDone={true}
      onChoose={onChoose}
    />
  );
};
export default Races;
